import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_CONDOMINIO = "identity-service/identity/units";

const RESOURCES = {
	LIST_CONDOMINIOS: (id, deviceData) => {
		const params = new URLSearchParams();
		if (deviceData != null) params.append('deviceData', deviceData);
		const query = params.size ? `?${params.toString()}` : '';
		return `${BASE_CONDOMINIO}/organizations/${id}${query}`;
	},

	LIST_OPERATOR_CONDOMINIUMS: (id) => `identity-service/access-management/users/accessible/units`,

	LIST_SCOPE_TAGS_BY_TYPES: (parentId, types) => `${BASE_CONDOMINIO}/${parentId}/scope-tags?types=${types.join(',')}`,

	LIST_RESPONSIBLES: (id) => `identity-service/identity/units/responsibles/${id}`,

	LIST_CLIENT_CONDOMINIOS_PAGINATED: (page, searchText, clientID, orderBy, deviceData, itemsPerPage = 8, listInOrganization = true) => {
		const params = new URLSearchParams({
			page,
			itemsPerPage,
			searchBy: searchText,
			orderBy: orderBy.collumnTitle,
			orderDirection: orderBy.orderDirection,
		});
		if (deviceData != null) params.append('deviceData', deviceData);
		if (listInOrganization) params.append('listInOrganization', 'true');
		return `${BASE_CONDOMINIO}/organizations/${clientID}/paginated?${params.toString()}`;
	},

	DELETE_CONDOMINIO: (id) => `${BASE_CONDOMINIO}/${id}`,

	UPDATE_OPERADOR_CONDOMINIO: (idOperator) =>
		`${BASE_CONDOMINIO}/persons/${idOperator}`,

	GET_ONE: (id) => `${BASE_CONDOMINIO}/${id}`,
};

class CondominioService {
	static async listCondominiumsByOperatorId(operatorId) {
		try {
			return await axios.get(RESOURCES.LIST_OPERATOR_CONDOMINIUMS(operatorId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar unidades do operador",
			});
			return error.response;
		}
	}

	static async loadUnitAddress(unitId) {
		try {
			return await axios.get(`${BASE_CONDOMINIO}/${unitId}/address`);
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter endereço da unidade",
			});
		}
	}

	static async listCondominiosByClientId(clientId, deviceData) {
		try {
			const { data: response } = await axios.get(RESOURCES.LIST_CONDOMINIOS(clientId, deviceData));
			return {
				...response,
				items: response.items
			};
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro listar unidades do cliente",
			});
			return error.response;
		}
	}

	static async listScopeTagsByTypes(parentId, types) {
		try {
			return await axios.get(RESOURCES.LIST_SCOPE_TAGS_BY_TYPES(parentId, types));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar etiquetas de escopo",
			});
			return error.response;
		}
	}


	static async listClientCondominiosPaginated(
		page,
		searchText,
		clientID,
		orderBy,
		deviceData,
		itemsPerPage = 8,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_CLIENT_CONDOMINIOS_PAGINATED(
					page,
					searchText,
					clientID,
					orderBy,
					deviceData,
					itemsPerPage,
				),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro listar unidades do cliente",
			});
			return error.response;
		}
	}

	static async listResponsibles(unitId) {
		try {
			return await axios.get(RESOURCES.LIST_RESPONSIBLES(unitId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar responsáveis pela unidade",
			});
			return error.response;
		}
	}

	static async getOne(id) {
		try {
			return await axios.get(RESOURCES.GET_ONE(id));
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter unidade",
			});
			return error.response;
		}
	}

	static async createCondominio(payload) {
		try {
			const response = await axios.post(BASE_CONDOMINIO, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Unidade cadastrada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao criar unidade",
			});
			return error.response;
		}
	}

	static async deleteCondominio(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_CONDOMINIO(id));
			ResponseAlerts({
				response: response,
				successMessage: response?.data?.message ?? "Unidade excluída com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao excluir unidade",
			});
			return error.response;
		}
	}

	static async updateCondominio(id, payload) {
		return await axios
			.put(`${BASE_CONDOMINIO}/${id}`, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Unidade atualizada com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao atualizar unidade",
				});
				return error.response;
			});
	}

	static async updateOperatorCondominiumsRelation(
		idOperador,
		condominios,
		condominiosExcluidos,
	) {
		const payload = {
			condominiums: condominios,
			deletedCondominiums: condominiosExcluidos,
		};
		return await axios
			.patch(RESOURCES.UPDATE_OPERADOR_CONDOMINIO(idOperador), payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Operadores da unidade atualizados com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar operadores da unidade",
				});
				return error.response;
			});
	}
}

export default CondominioService;
